/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A selectable consent tier for an MCP request (the token's scope ceiling).
 */
export type ConsentAccessLevel = {
    level: ConsentAccessLevel.level;
    scopes: Array<string>;
    already_granted: boolean;
};
export namespace ConsentAccessLevel {
    export enum level {
        READ = 'read',
        FULL = 'full',
    }
}

